/** Assumed viewport width during SSR. Must match the value passed to `provideSSRWidth()` in both ssr.ts and app.ts to prevent hydration mismatches. */
export const ssrViewportWidthPx = 1280;
